import Qs from 'qs'
import axios from 'axios'
import store from '../store'
import { getToken } from '@/utils/auth'
import { Message, MessageBox } from 'element-ui'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000 // 请求超时时间
})

// request拦截器
request.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['token'] = getToken() ? getToken() : "" // 让每个请求携带自定义token 请根据实际
  } else {
    config.headers['token'] = ""
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
request.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    console.log("response11111===>", response);
    // 新增导出文件处理逻辑
    if (response.config.isExport) {
      return response;
    }

    const res = response.data;
    if (res.errCode && res.errCode !== 0) {
      // 401:未登录;
      if (res.errCode === 401 || res.errCode === 400003) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      if (res.errCode == 1) {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }
      return Promise.reject(res.message)
    } else if (res.errCode == 0) {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);

function deleteEmptyProperty(obj) {
  var object = obj;
  for (var i in object) {
    var value = object[i];
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        if (value.length == 0) {
          delete object[i];
          continue;
        }
      }
      deleteEmptyProperty(value);
    } else {
      if (value === '' || value === null || value === undefined) {
        delete object[i];
      }
    }
  }
  return object;
}

function getRequest(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'GET');
}

function getRequestJson(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'GET', 1);
}

function postRequest(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'POST');
}

function postRequestJson(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'POST', 1);
}

// 新增导出专用请求方法
function getExportRequest(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'GET', 0, true);
}

function postExportRequest(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'POST', 1, true);
}

function request_fuc(url, params, method, isJson, isExport=false) {
  return request({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' || method === 'DELETE' ? (isJson == 1 ? JSON.stringify(params) : params) : null,
    params: method === 'GET' ? params : null,
    isExport: isExport,
    responseType: isExport ? 'blob' : 'json',
    // 请求头携带信息，类型默认为form,键值模式，传参为1
    headers: {
      'Content-Type': isJson && isJson === 1 ? 'application/json' : 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    transformRequest: [function (data) {
      if (isJson !== 1) {
        data = Qs.stringify(data);
      }
      return data;
    }],
  })
}

export default {
  request,
  getRequest,
  getRequestJson,
  postRequest,
  postRequestJson,
  getExportRequest,  // 导出新增方法
  postExportRequest  // 导出新增方法
}



// WEBPACK FOOTER //
// ./src/utils/request.js